import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class OperationsService {
  allOperations(idUser) {
    return api.get(
      UtilsUrl.productionURL() + "/operations/allOperations/" + idUser
    );
  }

  getOperationById(id) {
    return api.get(
      UtilsUrl.productionURL() + "/operations/getOperationById/" + id
    );
  }

  addOperation(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/operations/addOperation",
      modal
    );
  }
  updateOperation(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/operations/updateOperation",
      modal
    );
  }
  updateOperationWorkstation(idUser,idOperation,idWorkstation) {
    return api.get(
      UtilsUrl.productionURL() + "/operations/updateOperationWorkstation/"+idUser+"/"+idOperation+"/"+idWorkstation
    );
  }
}
export default new OperationsService();
